module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'devices'
      }
    }
  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Stream")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading && !_vm.videos.length),
      expression: "loading && !videos.length"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.grid), function(row, row_index) {
    return _c('el-row', {
      key: ("row" + row_index)
    }, _vm._l((row), function(video, column_index) {
      return _c('el-col', {
        key: ("row" + column_index),
        attrs: {
          "md": 24,
          "lg": 12
        }
      }, [_c('Player', {
        attrs: {
          "src": video
        }
      })], 1)
    }), 1)
  }), 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-badc9b88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/Stream.vue
// module id = 1167
// module chunks = 2